'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { connect } from 'react-redux';
import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaRight from 'UIComponents/layout/UIMediaRight';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { AudienceSources, Networks } from 'AdsUI/lib/Constants';
import { acceptAudienceToSForAccounts } from 'AdsUI/actions/AudiencesActions';
import { getAdAccounts } from 'AdsUI/selectors/AccountsSelectors';
import { hasWriteScope } from 'AdsUI/selectors/AuthSelectors';
import CurrentUserNotConnected from '../CurrentUserNotConnected';

class FacebookToSChangedBanner extends Component {
  constructor(props) {
    super(props);
    this.handleAcceptButtonClick = this.handleAcceptButtonClick.bind(this);
  }

  handleAcceptButtonClick() {
    const {
      fbAccountsWithUnacceptedToS
    } = this.props;
    const adNetworkAccountIdsMap = fbAccountsWithUnacceptedToS.reduce((networkToAccountIdMap, accountId) => {
      return networkToAccountIdMap.updateIn([Networks.FACEBOOK], accountIds => accountIds.add(accountId));
    }, ImmutableMap({
      [Networks.FACEBOOK]: ImmutableSet()
    }));
    this.props.acceptAudienceToSForAccounts({
      audienceSource: AudienceSources.HUBSPOT_CONTACT_LIST,
      adNetworkAccountIdsMap
    });
  }

  render() {
    const {
      fbAccountsWithUnacceptedToS,
      adAccounts,
      hasAdsWrite
    } = this.props;
    const accounts = fbAccountsWithUnacceptedToS.map(accountIdWithUnacceptedToS => {
      return adAccounts.find(account => account.accountId === accountIdWithUnacceptedToS);
    });
    const accountNames = accounts.map(account => account.accountName).toArray();
    const needConnectedUsers = accounts.some(account => !account.currentUserHasConnected);
    const needPermissions = accounts.some(account => !account.canCreateAudiences);
    const actionString = I18n.text(`noWritePermission.actions.performThisAction`);
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "facebookToSChanged.header"
      }),
      type: "danger",
      closeable: false,
      className: "m-bottom-5",
      children: /*#__PURE__*/_jsxs(UIMedia, {
        align: "baseline",
        children: [/*#__PURE__*/_jsx(UIMediaBody, {
          children: /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "facebookToSChanged.message",
              options: {
                formattedAccounts: I18n.formatList(accountNames)
              }
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: "https://www.facebook.com/legal/terms/customaudience",
              use: "on-bright",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "facebookToSChanged.link"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(UIMediaRight, {
          children: /*#__PURE__*/_jsx(UITooltip, {
            disabled: hasAdsWrite && !needConnectedUsers && !needPermissions,
            title: !hasAdsWrite ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "noWritePermission.notAuthorized",
              options: {
                action: actionString
              }
            }) : needConnectedUsers ? /*#__PURE__*/_jsx(CurrentUserNotConnected, {
              network: Networks.FACEBOOK,
              action: "acceptToS"
            }) : needPermissions ? /*#__PURE__*/_jsx(FormattedMessage, {
              message: "facebookToSChanged.permissions"
            }) : null,
            children: /*#__PURE__*/_jsx(UIButton, {
              use: "tertiary",
              size: "extra-small",
              className: "m-left-15",
              onClick: this.handleAcceptButtonClick,
              disabled: !hasAdsWrite || needConnectedUsers || needPermissions,
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "facebookToSChanged.acceptButton"
              })
            })
          })
        })]
      })
    });
  }

}

const select = state => {
  return {
    adAccounts: getAdAccounts(state),
    fbAccountsWithUnacceptedToS: state.fbAccountsWithUnacceptedToS,
    hasAdsWrite: hasWriteScope(state)
  };
};

export default connect(select, {
  acceptAudienceToSForAccounts
})(FacebookToSChangedBanner);